import React from 'react';
import { Tooltip } from 'antd';
import 'baseComponents/TooltipComponent/tooltipComponent.scss';

interface Props {
  text: string;
}

export const TooltipComponent: React.FC<React.PropsWithChildren<Props>> = (
  props
) => {
  return (
    <Tooltip
      arrow={false}
      title={props.text}
      placement='right'
      overlayClassName='tooltip'
    >
      {props.children}
    </Tooltip>
  );
};
